import React, { useState, useEffect } from 'react'
import { CLOUD_LOGIN_ALERTS } from '../../../../../Utils/GlobalConstants';
import { api } from '../../../../../Utils/API';
import Popup from 'reactjs-popup';
import { Button, Container } from 'react-bootstrap';
import './styles.scss';
import Toast from '../../../../../GlobalComponents/Toast';
import { TOAST_ERROR_ICON_COLOR, TOAST_SUCCESS_ICON_COLOR } from '../../../../../Utils/ColorsConfiguration';

const CSPUserNotificationPopup = ({ cspNotificationsPopupFlag, setCspNotificationsPopupFlag,setTriggerNotificationsPopup,triggerNotificationsPopup, Logout}) => {
  const [cloudLoginAlertData, setCloudLoginAlertData] = useState(null);  
  const [ipAddress, setIpAddress] = useState(null);

  const userAgent = navigator.userAgent;
  const browserName = userAgent.match(/(Chrome|Safari|Firefox|Edge|Opera|Internet Explorer)\//);
  const browserVersion = userAgent.match(/\((.*?)\)/);

  const [remindLaterArray, setRemindLaterArray] = useState(localStorage.getItem("cloud_remind_later_array") ? localStorage.getItem("cloud_remind_later_array") : []);

  // Header Authorization for General API's
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  // CSP Service alert Get Popup Data
  async function LoginAlertPopupDataLogin() {
    await api.get(CLOUD_LOGIN_ALERTS, config).then((resp) => {
      // handle success
      if(resp.status==204){
        setCspNotificationsPopupFlag(false);
        setTriggerNotificationsPopup(false);
      }
      else{
        let localData = [];
        resp.data.map((data)=>{
          if(!remindLaterArray.includes(data.alertId)){
            localData.push(data);
            setCloudLoginAlertData(localData);
          }
        })
        setCspNotificationsPopupFlag(true);
        setTriggerNotificationsPopup(false);
      }
    })
      .catch((error) => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
        }
      });
  }

  function generateRandomIp() {
    // Generate random IP address components
    const octets = [];
    for (let i = 0; i < 4; i++) {
      octets.push(Math.floor(Math.random() * 256).toString());
    }

    // Join the octets with dots to form the IP address
    const ipAddress = octets.join(".");

    return ipAddress;
  }

  // CSP Alert Okay Popup Data
  async function LoginAlertAcceptFunction(alertId,ipAddress,browser,close) {
    (ipAddress === undefined || ipAddress === null || ipAddress === "null") ? ipAddress = generateRandomIp() : ipAddress = ipAddress;
    let body = {
      "browser": browser,
      "ipAddress": ipAddress,
      "alertId": alertId
    }
    await api.post(CLOUD_LOGIN_ALERTS,body, config).then((resp) => {
      // handle success
      if(resp.status==200){
        close();
        if(!remindLaterArray.includes(alertId)){
        setRemindLaterArray((prev)=>[...prev,alertId])
        }
      }

    })
      .catch((error) => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        } else {

        }
      });
  }

  useEffect(() => {
    if(triggerNotificationsPopup){
      LoginAlertPopupDataLogin();
      fetch("https://api.ipify.org?format=json")
        .then(response => response.json())
        .then(data => setIpAddress(data.ip));
    }
  }, [triggerNotificationsPopup])

  useEffect(() => {
    if(remindLaterArray.length>0){
      console.log("Inside cloud_remind_later_array : ",remindLaterArray,localStorage.getItem("cloud_remind_later_array"))
      localStorage.setItem("cloud_remind_later_array", remindLaterArray);
    }

  }, [remindLaterArray])

  return (
    <>
      {cloudLoginAlertData && 
      cloudLoginAlertData.map((data)=>{
        return(
          <Popup
        className="custom-modal custom-modal-xl"
        open={cspNotificationsPopupFlag}
        closeOnEscape={false}
        modal
        nested
        //  contentStyle={{ width: '90% ' }}
        closeOnDocumentClick={false}
      >
        {(close) => (
          <div className="modal terms-conditions">
            <Container fluid className="p-4">
              <div className="content" dangerouslySetInnerHTML={{ __html: data.content }}>

              </div>

            </Container>
            <div className="actions">
              <Container fluid className="px-3 py-3">
                <div className="d-flex justify-content-end">
                  <Button
                    variant="light"
                    className="px-4 btn-border-light w-md-auto col-xs-12 mx-2 btn btn-md"
                    onClick={() => {
                      if(!remindLaterArray.includes(data.alertId)){
                        setRemindLaterArray((prev)=>[...prev,data.alertId])
                        close();
                      }

                    }}
                  >
                    Remind Me Later
                  </Button>
                  <Button
                    className="btn btn-md mx-2 "
                    onClick={() => {
                      // console.log("IP ADDRESS :",ipAddress,browserName[1],browserVersion[1]);
                      let browser = browserName[1] + " " + browserVersion[1];
                      LoginAlertAcceptFunction(data.alertId,ipAddress,browser,close);
                    }}
                  >
                    OK
                  </Button>
                </div>
              </Container>
            </div>
          </div> 
        )}
      </Popup>
        )
      })
      }
    </>
  )
}

export default CSPUserNotificationPopup